
<!-- For other Employee -->
 <div  *ngIf="showEmployeeDesktop">
<div class="row">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-6 col-lg-3 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-md-center">
              <i class="fa fa-calendar icon-lg text-primary"></i>
              <div class="ml-3 mr-3">
                <p class="mb-0">{{'dailyOrder' | translate}}</p>
                <h6>{{dailyOrder}} {{showTotalOrders ? (' / '+dailyTotalOrder):''}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-md-center">
              <i class="fa fa-check icon-lg text-success"></i>
              <div class="ml-3 mr-3">
                <p class="mb-0">{{'ordersCompleted' | translate}}</p>
                <h6>{{dailyCompleted}} {{showTotalOrders ? (' / '+dailyTotalCompleted):''}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-md-center">
              <i class="fa fa-dot-circle-o icon-lg text-info"></i>
              <div class="ml-3 mr-3">
                <p class="mb-0">{{'ordersInProgress' | translate}}</p>
                <h6>{{dailyInProgress}} {{showTotalOrders ? (' / '+dailyTotalInProgress):''}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-lg-3 grid-margin stretch-card" *ngIf="showCancelledOrders">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-md-center">
              <i class="fa fa-times icon-lg text-danger"></i>
              <div class="ml-3 mr-3">
                <p class="mb-0">{{'ordersCancelled' | translate}}</p>
                <h6>{{dailyCancelled}} {{showTotalOrders ? (' / '+dailyTotalCancelled):''}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-lg-3 grid-margin stretch-card" *ngIf="showTotalRevenue">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-md-center">
              <i class="fa fa-bar-chart-o icon-lg text-danger"></i>
              <div class="ml-3 mr-3">
                <p class="mb-0">{{'totalRevenue' | translate}}</p>
                <h6>{{dailyAmount | number : '1.2-2'}} {{showTotalOrders ? (' / '+(dailyTotalAmount | number :
                  '1.2-2')):''}} {{'aed' | translate}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 grid-margin stretch-card" *ngIf="!hideDelayed">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-md-center">
              <i class="fa fa-clock-o icon-lg text-danger"></i>
              <div class="ml-3 mr-3">
                <p class="mb-0">{{'totalDelayed' | translate}}</p>
                <h6>{{dashboardDelayedOrders?.length}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-12">
    <div class="row grid-margin">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h6 class="card-title">{{'todayOrders' | translate}} ({{0+dashboardTodayOrders?.length}})</h6>
            <div class="table-responsive" style="overflow-y: auto;max-height: 300px;">
              <table class="table mt-3 border-top">
                <thead>
                  <tr>
                    <th>{{'actions' | translate}}</th>
                    <th>{{'trackingNo' | translate}}</th>
                    <th>{{'category' | translate}}</th>
                    <th>{{'service' | translate}}</th>
                    <th>{{'implementation' | translate}}</th>
                    <th>{{'sessionDate' | translate}}</th>
                    <th>{{'createdOn' | translate}}</th>
                    <th>{{'status' | translate}}</th>
                    <th *ngIf="hidePaymentStatus === false">{{'paymentStatus' | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let order of dashboardTodayOrders">
                    <td class="request-row-action"><a class="main-color"
                        routerLink="/order/orderServiceDetails/{{order.id}}"> <i class="icon-eye fz-25"></i></a>
                    </td>
                    <td><a class="main-color" routerLink="/order/orderServiceDetails/{{order.id}}">{{
                        order.trackingNumber
                        }}</a></td>
                    <td>{{order.categoryName}}</td>
                    <td>{{order.serviceName}}</td>
                    <td>{{order.implementationName}}</td>
                    <td>{{order.sessionDate | customDate:"dd MMM, yyyy"}}</td>
                    <td>{{order.createdOn | customDate:"dd MMM, yyyy hh:mm a"}}</td>
                    <td>{{order.requestStatusName}}</td>
                    <td *ngIf="hidePaymentStatus === false">
                      <i *ngIf="order.paymentStatusId === paymentStatusEnum.Paid"
                        class="fa fa-check pl-1 pr-1 text-success"></i>
                      <i *ngIf="order.paymentStatusId !== paymentStatusEnum.Paid"
                        class="fa fa-clock-o pl-1 pr-1 text-danger"></i> {{order.paymentStatusName}}
                    </td>

                  </tr>

                </tbody>
                <tbody *ngIf="dashboardTodayOrders?.length == 0">
                  <tr>
                    <td colspan="8" class="no-data-available">{{'noDataFound' | translate}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-12" *ngIf="!hideDelayed">
    <div class="row grid-margin">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h6 class="card-title">{{'delayedOrders' | translate}} ({{0+dashboardDelayedOrders?.length}})</h6>
            <div class="table-responsive" style="overflow-y: auto;max-height: 300px;">
              <table class="table mt-3 border-top">
                <thead>
                  <tr>
                    <th>{{'actions' | translate}}</th>
                    <th>{{'trackingNo' | translate}}</th>
                    <th>{{'category' | translate}}</th>
                    <th>{{'service' | translate}}</th>
                    <th>{{'implementation' | translate}}</th>
                    <th>{{'sessionDate' | translate}}</th>
                    <th>{{'createdOn' | translate}}</th>
                    <th>{{'expectedDelivery' | translate}}</th>
                    <th>{{'status' | translate}}</th>
                    <th>{{'paymentStatus' | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let order of dashboardDelayedOrders">
                    <td class="request-row-action"><a class="main-color"
                        routerLink="/order/orderServiceDetails/{{order.id}}"> <i class="icon-eye fz-25"></i></a>
                    </td>
                    <td><a class="main-color" routerLink="/order/orderServiceDetails/{{order.id}}">{{
                        order.trackingNumber
                        }}</a></td>
                    <td>{{order.categoryName}}</td>
                    <td>{{order.serviceName}}</td>
                    <td>{{order.implementationName}}</td>
                    <td>{{order.sessionDate | customDate:"dd MMM, yyyy"}}</td>
                    <td>{{order.createdOn | customDate:"dd MMM, yyyy hh:mm a"}}</td>
                    <td>{{order.expectedDeliveryDate | customDate:"dd MMM, yyyy"}}</td>
                    <td>{{order.requestStatusName}}</td>
                    <td><i *ngIf="order.paymentStatusId === paymentStatusEnum.Paid"
                        class="fa fa-check pl-1 pr-1 text-success"></i>
                      <i *ngIf="order.paymentStatusId !== paymentStatusEnum.Paid"
                        class="fa fa-clock-o pl-1 pr-1 text-danger"></i>{{order.paymentStatusName}}
                    </td>

                  </tr>

                </tbody>
                <tbody *ngIf="dashboardDelayedOrders?.length == 0">
                  <tr>
                    <td colspan="9" class="no-data-available">{{'noDataFound' | translate}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</div>


<div class="row" style="display: none;">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-6 col-lg-3 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-md-center">
              <i class="mdi mdi-basket icon-lg text-success"></i>
              <div class="ml-3">
                <p class="mb-0">{{'dailyOrder' | translate}}</p>
                <h6>{{dailyOrder}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-md-center">
              <i class="mdi mdi-rocket icon-lg text-warning"></i>
              <div class="ml-3">
                <p class="mb-0">{{'ordersCompleted' | translate}}</p>
                <h6>{{dailyCompleted}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-md-center">
              <i class="mdi mdi-diamond icon-lg text-info"></i>
              <div class="ml-3">
                <p class="mb-0">{{'ordersInProgress' | translate}}</p>
                <h6>{{dailyInProgress}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-md-center">
              <i class="mdi mdi-chart-line-stacked icon-lg text-danger"></i>
              <div class="ml-3">
                <p class="mb-0">{{'totalRevenue' | translate}}</p>
                <h6>{{dailyAmount | number : '1.2-2'}} {{'aed' | translate}}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="row">
      <div class="col-md-3">
        <h3>Heading 2</h3>
        <p>This section takes 3 columns of the grid</p>
      </div>
      <div class="col-md-6 offset-md-3">
        <h3>Heading 2</h3>
        <p>This section takes 3 colums of the grid and is offset by 4 columns</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 d-flex flex-column">
        <div class="row flex-grow">
          <div class="col-12 col-md-4 col-lg-12 grid-margin stretch-card">
            <div class="card">
              <div class="card-body">
                <h6 class="card-title">Growth</h6>
                <div class="row">
                  <div class="col-12 text-center">
                    <div class="row">
                      <div class="col-6 border-right">
                        <h4>63%</h4>
                        <p>Monthly</p>
                      </div>
                      <div class="col-6">
                        <h4>20%</h4>
                        <p>Daily</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-3">
                  <div class="growthChartHeight">
                    <canvas baseChart [chartType]="'bar'" [datasets]="growthChartData" [labels]="growthChartLabels"
                      [options]="growthChartOptions" [colors]="growthChartColors"></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-12 grid-margin stretch-card">
            <div class="card bg-info">
              <div class="text-white py-3 px-4">
                <h6 class="card-title text-white mb-0">Page View</h6>
                <p>3669.25</p>
                <div class="chart-container">
                  <canvas baseChart [chartType]="'line'" height="50" [datasets]="pageViewChartData"
                    [labels]="pageViewChartLabels" [options]="pageViewChartOptions"
                    [colors]="pageViewChartColors"></canvas>
                </div>
                <small class="text-white">View Details</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-12 grid-margin stretch-card">
            <div class="card bg-success">
              <div class="text-white py-3 px-4">
                <h6 class="card-title text-white mb-0">Donations</h6>
                <p>$56569</p>
                <div class="chart-container">
                  <canvas baseChart [chartType]="'line'" height="50" [datasets]="pageViewChartData"
                    [labels]="pageViewChartLabels" [options]="pageViewChartOptions"
                    [colors]="donationChartColors"></canvas>
                </div>
                <small class="text-white">View Details</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h6 class="card-title">Daily Sales</h6>
            <div class="w-75 mx-auto">
              <div class="d-flex justify-content-between text-center">
                <div class="wrapper">
                  <h4>$2256</h4>
                  <small class="text-muted">Totel sales</small>
                </div>
                <div class="wrapper">
                  <h4>584</h4>
                  <small class="text-muted">Compaign</small>
                </div>
              </div>
              <div mk-morris-js [data]="chartDonutData" [options]="chartDonutOptions" type="Donut"></div>
            </div>
            <div id="legend" class="donut-legend">
              <span><span class="bg-info">&nbsp;</span>Download Sales</span>
              <span><span class="bg-success">&nbsp;</span>In-Store Sales</span>
              <span><span class="bg-light">&nbsp;</span>Mail-Order Sales</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h6 class="card-title">Total Revenue</h6>
            <div class="w-75 mx-auto">
              <div class="d-flex justify-content-between text-center mb-5">
                <div class="wrapper">
                  <h4>6,256</h4>
                  <small class="text-muted">Totel sales</small>
                </div>
                <div class="wrapper">
                  <h4>8569</h4>
                  <small class="text-muted">Open Compaign</small>
                </div>
              </div>
            </div>
            <div mk-morris-js [data]="chartLineData" [options]="chartLineOptions" type="Line"></div>
            <div class="w-75 mx-auto">
              <div class="d-flex justify-content-between text-center mt-5">
                <div class="wrapper">
                  <h4>5136</h4>
                  <small class="text-muted">Online Sales</small>
                </div>
                <div class="wrapper">
                  <h4>4596</h4>
                  <small class="text-muted">Store Sales</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row grid-margin">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h6 class="card-title">Order status</h6>
            <div class="d-flex table-responsive">
              <div class="btn-group mr-2">
                <button class="btn btn-sm btn-info"><i class="mdi mdi-plus-circle-outline"></i> Add</button>
              </div>
              <div class="btn-group mr-2">
                <button type="button" class="btn btn-light"><i class="mdi mdi-alert-circle-outline"></i></button>
                <button type="button" class="btn btn-light"><i class="mdi mdi-delete-empty"></i></button>
              </div>
              <div class="btn-group mr-2">
                <button type="button" class="btn btn-light"><i class="mdi mdi-printer"></i></button>
              </div>
              <div class="btn-group ml-auto mr-2 border-0">
                <input type="text" class="form-control" placeholder="Search Here">
              </div>
              <div class="btn-group">
                <button type="button" class="btn btn-light"><i class="mdi mdi-cloud"></i></button>
                <button type="button" class="btn btn-light"><i class="mdi mdi-dots-vertical"></i></button>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table mt-3 border-top">
                <thead>
                  <tr>
                    <th>Invoice</th>
                    <th>Customer</th>
                    <th>Ship</th>
                    <th>Best Price</th>
                    <th>Purchsed Price</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>50014</td>
                    <td>David Grey</td>
                    <td>Italy</td>
                    <td>$6300</td>
                    <td>$2100</td>
                    <td>
                      <div class="badge badge-success badge-fw">Progress</div>
                    </td>
                  </tr>
                  <tr>
                    <td>50015</td>
                    <td>Stella Johnson</td>
                    <td>Brazil</td>
                    <td>$4500</td>
                    <td>$4300</td>
                    <td>
                      <div class="badge badge-warning badge-fw">Open</div>
                    </td>
                  </tr>
                  <tr>
                    <td>50016</td>
                    <td>Marina Michel</td>
                    <td>Japan</td>
                    <td>$4300</td>
                    <td>$6440</td>
                    <td>
                      <div class="badge badge-danger badge-fw">On hold</div>
                    </td>
                  </tr>
                  <tr>
                    <td>50017</td>
                    <td>John Doe</td>
                    <td>India</td>
                    <td>$6400</td>
                    <td>$2200</td>
                    <td>
                      <div class="badge badge-success badge-fw">Progress</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="d-flex align-items-center justify-content-between flex-column flex-sm-row mt-4">
              <p class="mb-3 mb-sm-0">Showing 1 to 20 of 20 entries</p>
              <nav>
                <ul class="pagination pagination-info mb-0">
                  <li class="page-item"><a class="page-link"><i class="mdi mdi-chevron-left"></i></a></li>
                  <li class="page-item active"><a class="page-link">1</a></li>
                  <li class="page-item"><a class="page-link">2</a></li>
                  <li class="page-item"><a class="page-link">3</a></li>
                  <li class="page-item"><a class="page-link">4</a></li>
                  <li class="page-item"><a class="page-link"><i class="mdi mdi-chevron-right"></i></a></li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h6 class="card-title">Monthly Analytics</h6>
            <p class="card-description">Products that are creating the most revenue and their sales throughout the year
              and the variation in behavior of sales.</p>
            <div id="js-legend" class="chartjs-legend mt-4 mb-5"></div>
            <div class="demo-chart">
              <canvas baseChart [chartType]="'line'" [datasets]="monthlyAnalyticChartData"
                [labels]="monthlyAnalyticChartLabels" [options]="monthlyAnalyticChartOptions"
                [colors]="monthlyAnalyticChartColors"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-lg-4 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between">
              <h6 class="card-title">Activity</h6>
            </div>
            <p class="card-description">What's people doing right now</p>
            <div class="list d-flex align-items-center border-bottom py-3">
              <img class="img-sm rounded-circle" src="https://via.placeholder.com/86x86" alt="">
              <div class="wrapper w-100 ml-3">
                <p class="mb-0"><b>Dobrick </b>posted in Material</p>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <i class="mdi mdi-clock text-muted mr-1"></i>
                    <p class="mb-0">Awesome!</p>
                  </div>
                  <small class="text-muted ml-auto">2 hours ago</small>
                </div>
              </div>
            </div>
            <div class="list d-flex align-items-center border-bottom py-3">
              <img class="img-sm rounded-circle" src="https://via.placeholder.com/86x86" alt="">
              <div class="wrapper w-100 ml-3">
                <p class="mb-0"><b>Stella </b>posted in Material</p>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <i class="mdi mdi-clock text-muted mr-1"></i>
                    <p class="mb-0">Awesome!</p>
                  </div>
                  <small class="text-muted ml-auto">3 hours ago</small>
                </div>
              </div>
            </div>
            <div class="list d-flex align-items-center border-bottom py-3">
              <img class="img-sm rounded-circle" src="https://via.placeholder.com/86x86" alt="">
              <div class="wrapper w-100 ml-3">
                <p class="mb-0"><b>Peter </b>posted in Material</p>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <i class="mdi mdi-clock text-muted mr-1"></i>
                    <p class="mb-0">Great!</p>
                  </div>
                  <small class="text-muted ml-auto">1 hours ago</small>
                </div>
              </div>
            </div>
            <div class="list d-flex align-items-center pt-3">
              <img class="img-sm rounded-circle" src="https://via.placeholder.com/86x86" alt="">
              <div class="wrapper w-100 ml-3">
                <p class="mb-0"><b>Nateila </b>posted in Material</p>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-flex align-items-center">
                    <i class="mdi mdi-clock text-muted mr-1"></i>
                    <p class="mb-0">Awesome!</p>
                  </div>
                  <small class="text-muted ml-auto">1 hours ago</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h6 class="card-title">Sales Difference</h6>
            <p>Sales difference with last year</p>
          </div>
          <div mk-morris-js [data]="salesDifferenceData" [options]="salesDifferenceOptions" type="Area"></div>
        </div>
      </div>
      <div class="col-12 col-lg-4 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h6 class="card-title">Sales Chart</h6>
            <p class="card-description">Based on last month analytics.</p>
            <div class="btn-group" role="group" aria-label="Basic example">
              <button type="button" class="btn btn-outline-secondary">2015</button>
              <button type="button" class="btn btn-outline-secondary">2016</button>
            </div>
            <div class="barchart-wrap">
              <div mk-morris-js [data]="lastMonthAnalyticData" [options]="lastMonthAnalyticOptions" type="Bar"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 grid-margin stretch-card">
        <div class="card">
          <div class="card-body pb-0">
            <h6 class="card-title">Reviews</h6>
            <div class="row">
              <div class="col-12">
                <div class="wrapper border-bottom py-2">
                  <div class="d-flex">
                    <img class="img-sm rounded-circle" src="https://via.placeholder.com/86x86" alt="">
                    <div class="wrapper ml-4">
                      <p class="mb-0">Sarah Graves</p>
                      <small class="text-muted mb-0">Awesome!!! Highly recommend</small>
                    </div>
                    <div class="rating ml-auto d-flex align-items-center">
                      <bar-rating [(rate)]="fontAwesomeRate" [max]="5" [theme]="'fontawesome'"></bar-rating>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="wrapper border-bottom py-2">
                  <div class="d-flex">
                    <img class="img-sm rounded-circle" src="https://via.placeholder.com/86x86" alt="">
                    <div class="wrapper ml-4">
                      <p class="mb-0">David Grey</p>
                      <small class="text-muted mb-0">Not satisfied with the service.</small>
                    </div>
                    <div class="rating ml-auto d-flex align-items-center">
                      <bar-rating [(rate)]="fontAwesomeRate1" [max]="5" [theme]="'fontawesome'"></bar-rating>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="wrapper border-bottom py-2">
                  <div class="d-flex">
                    <img class="img-sm rounded-circle" src="https://via.placeholder.com/86x86" alt="">
                    <div class="wrapper ml-4">
                      <p class="mb-0">Burno mars</p>
                      <small class="text-muted mb-0">Great!! It's the best</small>
                    </div>
                    <div class="rating ml-auto d-flex align-items-center">
                      <bar-rating [(rate)]="fontAwesomeRate2" [max]="5" [theme]="'fontawesome'"></bar-rating>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="wrapper py-2">
                  <div class="d-flex">
                    <img class="img-sm rounded-circle" src="https://via.placeholder.com/86x86" alt="">
                    <div class="wrapper ml-4">
                      <p class="mb-0">Dobrick</p>
                      <small class="text-muted mb-0">Not worth the money.</small>
                    </div>
                    <div class="rating ml-auto d-flex align-items-center">
                      <bar-rating [(rate)]="fontAwesomeRate3" [max]="5" [theme]="'fontawesome'"></bar-rating>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 stretch-card">
        <div class="row flex-grow">
          <div class="col-12 grid-margin stretch-card">
            <div class="card">
              <div class="card-body">
                <h6 class="card-title mb-0">Statistics</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-inline-block pt-3">
                    <div class="d-lg-flex">
                      <h2 class="mb-0">$10,200</h2>
                      <div class="d-flex align-items-center ml-lg-2">
                        <i class="mdi mdi-clock text-muted"></i>
                        <small class="ml-1 mb-0">Updated: 9:10am</small>
                      </div>
                    </div>
                    <small class="text-gray">Raised from 89 orders.</small>
                  </div>
                  <div class="d-inline-block">
                    <div class="bg-success px-3 px-md-4 py-2 rounded">
                      <i class="mdi mdi-buffer text-white icon-lg"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 grid-margin stretch-card">
            <div class="card">
              <div class="card-body">
                <h6 class="card-title mb-0">Daily Order</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <div class="d-inline-block pt-3">
                    <div class="d-lg-flex">
                      <h2 class="mb-0">$2256</h2>
                      <div class="d-flex align-items-center ml-lg-2">
                        <i class="mdi mdi-clock text-muted"></i>
                        <small class="ml-1 mb-0">Updated: 05:42pm</small>
                      </div>
                    </div>
                    <small class="text-gray">hey, let’s have lunch together</small>
                  </div>
                  <div class="d-inline-block">
                    <div class="bg-warning px-3 px-md-4 py-2 rounded">
                      <i class="mdi mdi-wallet text-white icon-lg"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 grid-margin">
        <div class="card">
          <div class="card-body">
            <div class="wrapper d-md-flex align-items-center justify-content-center text-center text-md-left">
              <i class="mdi mdi-facebook icon-lg text-facebook"></i>
              <div class="wrapper ml-md-3">
                <p class="text-facebook mb-0 font-weight-medium">15k Likes</p>
                <small class="text-muted mb-0">You main list growing !</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 grid-margin">
        <div class="card">
          <div class="card-body">
            <div class="wrapper d-md-flex align-items-center justify-content-center text-center text-md-left">
              <i class="mdi mdi-twitter icon-lg text-twitter"></i>
              <div class="wrapper ml-md-3">
                <p class="text-twitter mb-0 font-weight-medium">18k followers</p>
                <small class="text-muted mb-0">There you are !</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 grid-margin">
        <div class="card">
          <div class="card-body">
            <div class="wrapper d-md-flex align-items-center justify-content-center text-center text-md-left">
              <i class="mdi mdi-linkedin icon-lg text-linkedin"></i>
              <div class="wrapper ml-md-3">
                <p class="text-linkedin mb-0 font-weight-medium">5k connections</p>
                <small class="text-muted mb-0">Going good !</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 grid-margin">
        <div class="card">
          <div class="card-body">
            <div class="wrapper d-flex align-items-center justify-content-start justify-content-sm-center">
              <img class="img-md rounded" src="https://via.placeholder.com/86x86" alt="">
              <div class="wrapper ml-4">
                <p class="mb-0 font-weight-medium">Tim Cook</p>
                <small class="text-muted mb-0">timcook@gmail.com</small>
                <p class="text-success mb-0 font-weight-medium">Designer</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 grid-margin">
        <div class="card">
          <div class="card-body">
            <div class="wrapper d-flex align-items-center justify-content-start justify-content-sm-center">
              <img class="img-md rounded" src="https://via.placeholder.com/86x86" alt="">
              <div class="wrapper ml-4">
                <p class="mb-0 font-weight-medium">Sarah Graves</p>
                <small class="text-muted mb-0">Sarahgraves@gmail.com</small>
                <p class="text-success mb-0 font-weight-medium">Developer</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 grid-margin">
        <div class="card">
          <div class="card-body">
            <div class="wrapper d-flex align-items-center justify-content-start justify-content-sm-center">
              <img class="img-md rounded" src="https://via.placeholder.com/86x86" alt="">
              <div class="wrapper ml-4">
                <p class="mb-0 font-weight-medium">David Grey</p>
                <small class="text-muted mb-0">David@gmail.com</small>
                <p class="text-success mb-0 font-weight-medium">Support Lead</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>

<!-- FOr only Super Admin -->
<div class="row"  *ngIf="showAdminDesktop">
<app-dashboard-menu></app-dashboard-menu>
 
  <div class="selectPeriodPan">
    <label class="form-label">{{'SelectPeriod'|translate}}</label>
    <div class="col-sm-12 col-xs-12 col-md-4 col-lg-3">
      <div class="form-group row">
        <div class="col-sm-12 paddingLess">
          <ngx-datepicker #fromDate class="form-control form-control-lg p-15 priodDateBox" id="fromDate"
            [options]="fromDatePickeroptions" [(ngModel)]="selectedFilters.fromDate" aria-placeholder="Select">

          </ngx-datepicker>
          <i *ngIf="selectedFilters.fromDate && selectedFilters.fromDate !==null"
            class="fa fa-times c-pointer clear-datepicker-icon" (click)="clearFromDate()"></i>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-xs-12 col-md-4 col-lg-3">
      <div class="form-group row">
        <div class="col-sm-12 paddingLess">
          <ngx-datepicker #toDate class="form-control form-control-lg p-15 priodDateBox" id="toDate" [options]="toDatePickeroptions"
            [(ngModel)]="selectedFilters.toDate">

          </ngx-datepicker>
          <i *ngIf="selectedFilters.toDate && selectedFilters.toDate !==null"
            class="fa fa-times c-pointer clear-datepicker-icon" (click)="clearToDate()"></i>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-xs-12 col-md-4 col-lg-3">
      <button class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn getButton" type="submit"
        (click)="getAdminDashboardCharts()">
        {{'get' | translate}}
      </button>
    </div>
    <!-- <input type="text" class="form-control" placeholder="from Jan 1, 2025 " aria-label="Select Period" aria-describedby="button-addon2">
    <input type="text" class="form-control" placeholder="to Dec 31, 2025" aria-label="Select Period" aria-describedby="button-addon2">         -->
  </div>
  <div class="selectPeriodInfo">
    <p>

      <span>{{'fromDate'|translate}} {{selectedFilters.fromDate|date:'d MMMM, y'}}</span>
      <span>{{'toDate'|translate}} {{selectedFilters.toDate|date:'d MMMM, y'}}</span>
    </p>
  </div>
  <div class="dashboardGridPannel">
    <div class="gridBoxCard">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="39.000000pt" height="50.000000pt"
        viewBox="0 0 350.000000 450.000000" preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,450.000000) scale(0.100000,-0.100000)" fill="#657e58" stroke="none">
          <path d="M1403 4490 c-145 -30 -263 -165 -263 -300 l0 -40 -53 0 c-108 0 -190
        -43 -216 -113 -6 -16 -11 -80 -11 -143 l0 -114 598 2 597 3 0 125 c0 116 -2
        127 -24 159 -31 43 -99 73 -182 79 l-66 5 -6 53 c-19 184 -197 319 -374 284z" />
          <path d="M141 4049 c-50 -10 -97 -48 -117 -96 -12 -27 -14 -326 -14 -1830 l0
        -1798 24 -51 c27 -57 64 -91 110 -99 17 -3 421 -4 898 -3 l867 3 -60 100 c-32
        55 -64 115 -70 132 l-11 33 -756 2 -757 3 -3 1668 -2 1667 215 0 215 0 0 118
        c0 64 3 127 6 140 l6 22 -253 -1 c-140 -1 -274 -5 -298 -10z" />
          <path d="M2225 4051 c-3 -6 -1 -19 5 -30 5 -11 10 -69 10 -130 l0 -111 215 0
        215 0 0 -995 0 -995 43 0 c43 0 144 -14 178 -25 19 -6 19 13 17 1083 l-3 1088
        -27 41 c-48 73 -66 77 -375 81 -176 2 -274 -1 -278 -7z" />
          <path d="M561 3264 c-27 -23 -31 -32 -31 -77 0 -42 5 -56 27 -79 l27 -28 859
        0 859 0 29 29 c39 39 41 106 5 148 l-24 28 -860 3 -860 2 -31 -26z" />
          <path d="M600 2793 c-56 -20 -83 -89 -56 -141 33 -65 10 -62 567 -62 l507 0
        31 29 c37 35 44 79 18 129 -25 52 -28 52 -559 51 -271 0 -500 -3 -508 -6z" />
          <path d="M590 2183 c-8 -3 -25 -15 -37 -26 -34 -30 -33 -114 2 -151 l24 -26
        862 0 863 0 28 27 c50 48 35 139 -29 172 -15 8 -261 11 -860 10 -461 0 -845
        -3 -853 -6z" />
          <path d="M582 1717 c-60 -34 -67 -108 -13 -147 28 -20 42 -20 543 -20 l514 0
        28 29 c46 48 32 120 -27 141 -46 16 -1015 13 -1045 -3z" />
          <path d="M2570 1584 c-530 -103 -814 -645 -591 -1126 40 -88 78 -140 157 -220
        270 -272 689 -313 1008 -98 71 48 171 152 219 227 235 365 134 848 -229 1092
        -130 87 -243 122 -414 126 -69 2 -136 1 -150 -1z m280 -189 c171 -45 324 -170
        398 -325 54 -114 66 -174 59 -306 -6 -133 -30 -206 -99 -309 -65 -98 -132
        -156 -242 -210 -294 -144 -645 -36 -806 248 -49 87 -71 164 -77 269 -11 183
        48 338 177 468 125 125 253 179 430 179 61 1 128 -5 160 -14z" />
          <path d="M2960 1099 c-148 -83 -287 -208 -381 -344 -52 -76 -54 -77 -68 -55
        -48 72 -88 124 -102 133 -19 12 -196 -40 -203 -59 -3 -7 25 -41 61 -76 69 -67
        136 -155 172 -225 31 -62 49 -68 113 -40 67 30 78 43 123 142 101 223 231 397
        365 488 25 16 47 32 50 34 9 8 -33 33 -54 33 -12 0 -46 -14 -76 -31z" />
        </g>
      </svg>
      <p>{{'requestsSumbited'| translate}}</p>
      <span class="numberText">{{this.requestsSumbited}}</span>
      <div class="boxBottomRightInfo">
        
      <span 
        [ngClass]="submitedOrderDiffPercentage < 0 ? 'boxrightinfoTextRed' : 'boxrightinfoText'">
        {{ submitedOrderDiffPercentage }}%
      </span>

        <!-- <span class="boxrightinfoText">+{{this.submitedOrderDiffPercentage}}%</span> -->
        <span class="boxrightinfoText blackColor">{{this.submitedOrderDiff}}{{'thisWeek'| translate}}</span>
      </div>
    </div>
    <div class="gridBoxCard">

      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="55.000000pt" height="50.000000pt"
        viewBox="0 0 124.000000 113.000000" preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,113.000000) scale(0.100000,-0.100000)" fill="#657e58" stroke="none">
          <path d="M22 1108 c-17 -17 -17 -1079 0 -1096 9 -9 156 -12 599 -12 626 0 616
        -1 607 47 -3 17 -34 18 -576 21 l-572 2 0 513 c0 518 -1 537 -35 537 -6 0 -16
        -5 -23 -12z" />
          <path d="M801 852 c-19 -36 4 -52 77 -52 l67 -1 -145 -140 c-80 -77 -160 -151
        -177 -165 l-32 -26 -68 56 c-37 31 -76 56 -86 56 -10 0 -81 -57 -158 -127
        -106 -96 -139 -131 -137 -147 2 -15 10 -21 30 -21 19 0 58 28 147 108 l121
        109 73 -61 c41 -34 79 -61 85 -61 6 0 98 82 204 182 l193 183 5 -68 c5 -66 16
        -86 47 -87 24 0 33 40 33 140 0 145 5 140 -145 140 -109 0 -125 -2 -134 -18z" />
        </g>
      </svg>

      <p>{{'inProgress'| translate}}</p>
      <span class="numberText">{{this.inProgress}}</span>
    </div>
    <div class="gridBoxCard">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50.000000pt" height="50.000000pt"
        viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">

        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#657e58" stroke="none">
          <path d="M2358 4920 c-480 -44 -931 -225 -1307 -528 -404 -324 -704 -800 -825
        -1308 -258 -1085 272 -2216 1268 -2704 236 -115 462 -187 716 -227 162 -25
        538 -25 700 0 535 85 1022 337 1384 718 558 587 782 1397 605 2192 -55 248
        -193 571 -337 787 -387 580 -985 956 -1677 1056 -127 18 -401 25 -527 14z
        m382 -321 c380 -34 724 -163 1044 -390 106 -76 302 -262 388 -368 513 -636
        611 -1498 254 -2227 -300 -610 -859 -1025 -1536 -1139 -153 -26 -420 -31 -580
        -10 -709 90 -1313 521 -1620 1157 -351 727 -253 1584 253 2213 86 107 283 296
        385 368 424 304 916 442 1412 396z" />
          <path d="M3716 3465 c-31 -11 -205 -179 -801 -775 -418 -418 -767 -760 -775
        -760 -8 0 -172 157 -365 349 -378 378 -372 373 -462 356 -49 -9 -109 -69 -118
        -118 -17 -91 -32 -74 468 -575 310 -310 468 -462 480 -460 9 2 407 390 884
        863 672 667 871 870 886 904 24 55 18 108 -18 160 -41 60 -111 82 -179 56z" />
        </g>
      </svg>

      <p>{{'completed'| translate}}</p>
      <span class="numberText">{{this.completed}}</span>
    </div>
    <div class="gridBoxCard">

      <svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50.000000pt" height="50.000000pt"
        viewBox="0 0 200.000000 200.000000" preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)" fill="#657e58" stroke="none">
          <path d="M320 1827 c-49 -16 -133 -102 -148 -153 -9 -30 -12 -183 -12 -565 0
            -506 1 -526 21 -569 25 -55 62 -95 114 -123 38 -21 55 -22 343 -25 327 -4 336
            -2 330 47 l-3 26 -305 5 c-337 6 -345 7 -392 72 l-23 33 0 542 c0 531 0 542
            21 569 11 15 33 37 48 48 26 20 41 21 417 24 435 3 434 3 487 -66 l27 -35 5
            -305 c5 -276 7 -306 23 -316 12 -8 22 -8 35 0 16 10 17 37 17 320 0 300 -1
            310 -22 350 -28 53 -91 107 -142 122 -52 16 -791 15 -841 -1z" />
          <path d="M612 1578 c-6 -6 -12 -20 -12 -29 0 -34 24 -40 150 -37 104 3 125 6
            134 21 8 12 8 22 0 35 -9 14 -30 17 -135 20 -88 2 -128 -1 -137 -10z" />
          <path d="M386 1347 c-11 -8 -17 -23 -14 -38 l3 -24 370 0 370 0 3 24 c7 49 -5
            51 -373 51 -265 0 -345 -3 -359 -13z" />
          <path d="M382 1188 c-16 -16 -15 -43 2 -57 9 -8 114 -11 366 -9 323 3 354 4
            364 21 8 12 8 22 0 35 -10 16 -41 17 -365 20 -268 2 -358 -1 -367 -10z" />
          <path d="M377 1033 c-17 -17 -6 -54 19 -63 34 -13 664 -13 699 0 21 8 26 16
            23 38 l-3 27 -366 3 c-201 1 -368 -1 -372 -5z" />
          <path d="M1330 999 c-213 -42 -370 -267 -331 -477 42 -229 255 -383 477 -345
            280 48 433 346 309 599 -52 107 -171 197 -293 223 -60 13 -98 13 -162 0z m161
            -63 c110 -25 197 -98 248 -205 22 -47 26 -70 26 -141 0 -72 -4 -94 -28 -146
            -36 -77 -104 -145 -182 -181 -51 -24 -73 -28 -145 -28 -71 0 -94 4 -142 27
            -114 53 -186 147 -209 270 -38 207 130 409 346 417 17 0 55 -5 86 -13z" />
          <path d="M1242 758 c-19 -19 -15 -26 55 -99 l66 -69 -67 -70 c-68 -70 -74 -85
            -43 -104 14 -9 29 2 87 59 l70 69 69 -68 c70 -69 93 -78 108 -40 4 11 -16 37
            -63 85 l-68 69 69 70 c57 58 68 73 59 87 -19 30 -32 25 -103 -43 l-71 -67 -69
            67 c-73 69 -80 73 -99 54z" />
          <path d="M382 878 c-7 -7 -12 -19 -12 -28 0 -38 16 -40 317 -40 282 0 293 1
            303 20 8 14 8 26 0 40 -10 19 -21 20 -303 20 -215 0 -296 -3 -305 -12z" />
          <path d="M377 723 c-14 -13 -6 -53 12 -63 12 -6 116 -10 268 -10 269 0 288 3
            281 51 l-3 24 -276 3 c-151 1 -278 -1 -282 -5z" />
        </g>
      </svg>
      <p>{{'deleted'|translate}}</p>
      <span class="numberText">{{this.deleted}}</span>
      <div class="boxBottomRightInfo">
        <span 
        [ngClass]="deletedOrderDiffPercentage < 0 ? 'boxrightinfoTextRed' : 'boxrightinfoText'">
        {{ deletedOrderDiffPercentage }}%
      </span>
        <!-- <span class="boxrightinfoText">+{{this.deletedOrderDiffPercentage}}%</span> -->
        <span class="boxrightinfoText blackColor">{{this.deletedOrderDiff}} {{'thisWeek'| translate}}</span>
      </div>
    </div>
  </div>


  <div class="DashboardContentArea">
    <div class="dashboardContentAreaLeft">
      <div class="dashboardContentBox">

        <div class="dashboardContentBoxHeading">
           
          {{'categories'|translate}}
        </div>
        
        <div class="dashboardContentBoxBody">
          <app-category *ngIf="ChartData" [item]="ChartData"></app-category>
         

          <div>


          </div>

        </div>
      </div>
      <div class="dashboardContentBox">
        <div class="dashboardContentBoxHeading">{{'incomePerQuarter'|translate}}</div>
        <div class="dashboardContentBoxBody">
          <div style="display: block">
            <canvas #doughnutCanvas></canvas>
          </div>



        </div>
      </div>
      <div class="dashboardContentBox">
        <div class="totalEarningsBox">
          <h2>{{'totalEarnings'|translate}}</h2>
          <p>{{this.totalEarning}} {{'aed' | translate}}</p>
        </div>
      </div>
    </div>
    <div class="dashboardContentAreaRight">
      <div class="dashboardContentBox">
        <div class="dashboardContentBoxHeading">{{'monthlySubmittedOrdersYearly'|translate}}
          
        </div>
        <div class="dashboardContentBoxBody">
          <!-- <app-montly-submitted-order-current-year [item]="ChartData"></app-montly-submitted-order-current-year> -->
          <app-submited-order-current-year *ngIf="ChartData" [item]="ChartData"></app-submited-order-current-year>
     



        </div>
      </div>
      <div class="dashboardContentBox">
        <div class="dashboardContentBoxHeading">{{'mostImplementationOrderYearly'|translate}}</div>
        <div class="dashboardContentBoxBody">

          <app-implantation-order-yearly *ngIf="ChartData" [item]="ChartData"></app-implantation-order-yearly>
        </div>
      </div>
      <div class="dashboardContentBox">
        <div class="dashboardContentBoxHeading">{{'IncomePerMonthYearly'|translate}}</div>
        <div class="dashboardContentBoxBody">
          <app-income-per-month-yearly *ngIf="ChartData" [item]="ChartData"></app-income-per-month-yearly>
        </div>
      </div>
 
        <div class="dashboardContentBox">
            <div class="dashboardContentBoxHeading">{{'mostServiceTypeOrderYearly'|translate}}</div>
            <div class="dashboardContentBoxBody">
            <app-service-type-current-year *ngIf="ChartData" [item]="ChartData"></app-service-type-current-year>

            </div>
        </div>
    </div>
  </div>


</div>


